import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNotEquals = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.33594 5.9987H12.6693M3.33594 9.9987H12.6693M12.6693 3.33203L3.33594 12.6654",
		stroke: "currentColor",
		strokeWidth: 1.2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgNotEquals;
